import { Dialog, Transition } from '@headlessui/react';
import clsx from 'clsx';
import type { ReactNode } from 'react';
import { Fragment } from 'react';
import { classNames } from '.';

interface IModalDialog {
	dialogOpen?: boolean;
	children: ReactNode;
	closeFn?: () => void;
	panelContainerClass?: string;
	zIndex?: string;
	maxW?: string;
}

export const ModalDialog = ({
	children,
	closeFn,
	dialogOpen = true,
	panelContainerClass = '',
	zIndex = 'z-1000',
	maxW = 'sm:max-w-lg',
}: IModalDialog) => {
	return (
		<Transition.Root show={dialogOpen} as={Fragment}>
			{/* NOTE: For the dialog, have to add the empty function to onClose to disable closing the dialog on clickaway/esc key press */}
			<Dialog as="div" className={classNames('relative', zIndex)} onClose={closeFn ? closeFn : () => undefined}>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div className="fixed inset-0 bg-primary-dark/50 transition-opacity mix-blend-multiply" />
				</Transition.Child>

				<div className={classNames('fixed inset-0 overflow-y-auto', zIndex)}>
					<div className="flex min-h-full items-end justify-center p-4 sm:items-center sm:p-0">
						<Transition.Child
							as={Fragment}
							enter="ease-out duration-300"
							enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
							enterTo="opacity-100 translate-y-0 sm:scale-100"
							leave="ease-in duration-200"
							leaveFrom="opacity-100 translate-y-0 sm:scale-100"
							leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
						>
							<Dialog.Panel
								className={clsx(
									`relative transform rounded-lg bg-white px-4 pt-5 pb text-left shadow-xl transition-all sm:w-full w-full sm:p-6 ${panelContainerClass}`,
									{
										[maxW]: maxW,
									}
								)}
							>
								{children}
							</Dialog.Panel>
						</Transition.Child>
					</div>
				</div>
			</Dialog>
		</Transition.Root>
	);
};
